import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_RangeFieldLayout = _resolveComponent("RangeFieldLayout")!

  return (_openBlock(), _createBlock(_component_RangeFieldLayout, { labels: _ctx.labels }, {
    from: _withCtx(() => [
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.fromModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromModel) = $event)),
        type: "time",
        mod: "rectangular",
        required: _ctx.required,
        disabled: _ctx.disabled,
        isDirtyValidation: ""
      }, null, 8, ["modelValue", "required", "disabled"])
    ]),
    to: _withCtx(() => [
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.toModel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toModel) = $event)),
        type: "time",
        mod: "rectangular",
        required: _ctx.required,
        disabled: _ctx.disabled,
        isDirtyValidation: ""
      }, null, 8, ["modelValue", "required", "disabled"])
    ]),
    _: 1
  }, 8, ["labels"]))
}